{
  "DE": "Germany",
  "AT": "Austria", 
  "BE": "Belgium",
  "DK": "Denmark",
  "ES": "Spain",
  "FR": "France",
  "IE": "Ireland",
  "IT": "Italy",
  "LU": "Luxembourg",
  "MC": "Monaco",
  "NL": "Netherlands",
  "PL": "Poland", 
  "PT": "Portugal",
  "SE": "Sweden"
}
